import * as Sentry from "@sentry/browser";
import React from "react";
import { hydrate } from "react-dom";

import ReportForm from "../../form";
import sendBeacon from "../../form/beacon";
import { i18nContext } from "../../translation/frontend";
import "../css/globals.css";
import CookieBanner from "./cookieBanner";
import CookieControl, { cookieAllowed, cookieBlocked, loadGoogleAnalytics } from "./cookieControl";
import initTitleObscurer from "./titleObscurer";
import wireUpFormLinks from "./wire-up-form-links";

const uuids = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

export default function main() {
  document.body.classList.add("js");

  Sentry.init({
    dsn: "https://9ff38e13b46b4cf9967754906b046d5b@o392151.ingest.sentry.io/5240403",
    release: process.env.REACT_APP_SENTRY_RELEASE,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT,
    beforeBreadcrumb: (breadcrumb) => {
      const redactedBreadcrumb = {
        ...breadcrumb,
        message: breadcrumb.message?.replace(uuids, "REDACTED-UUID"),
      };
      return redactedBreadcrumb;
    },
  });

  window.addEventListener("DOMContentLoaded", () => {
    const language = document.querySelector("html")!.getAttribute("lang")!;

    const cookieControlCheckbox = document.getElementById("cookie-control") as HTMLInputElement | null;
    if (cookieControlCheckbox) {
      new CookieControl(cookieControlCheckbox).init();
    }

    if (document.body.dataset.googleAnalyticsEnabled === "true") {
      if (cookieAllowed()) {
        loadGoogleAnalytics();
      } else if (!cookieBlocked()) {
        new CookieBanner(document.getElementById("cookie-banner") as HTMLDivElement).init();
      }
    }

    for (const el of document.querySelectorAll(".navbar__button")) {
      el.addEventListener("click", () => document.body.classList.toggle("is-mobile-nav"));
    }
    const form = document.getElementById("report-form-target");
    if (form) {
      hydrate(
        <i18nContext.Provider value={language}>
          <ReportForm
            formId={form.dataset.formId!}
            csrfToken={form.dataset.csrfToken!}
            pageHistory={form.dataset.pageHistory!.split(",").map((p) => parseInt(p, 10))}
            pages={JSON.parse(form.dataset.pages!)}
            answers={JSON.parse(form.dataset.answers!)}
            sessionId={form.dataset.sessionId!}
          />
        </i18nContext.Provider>,
        form,
      );
    } else {
      if (document.body.dataset.objectType && document.body.dataset.objectId) {
        sendBeacon(document.body.dataset.objectType, document.body.dataset.objectId, null, null, null);
      }
    }

    initTitleObscurer();
    wireUpFormLinks();
  });
}
